import {Button, HStack, Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {FC} from 'react';

const defaultTips = [3, 5, 10, 20];

interface Props {
  tips: number;
  onChange: (value: number) => void;
}

export const Tips: FC<Props> = ({tips, onChange}) => {
  const handleChange = (value: number) => {
    if (value === tips) {
      onChange(0);
    } else {
      onChange(value);
    }
  };

  return (
    <IconBlock heading="Mulțumește-i curierului" icon="/icons/delivery.svg">
      <Text fontSize="14px" fontWeight="500" color={colors.textGray} mb="1rem">
        Nu este obligatoriu, dar este o variantă prietenoasă de a arăta că îi apreciezi eforturile.
      </Text>
      <HStack>
        {defaultTips.map((value, index) => {
          const isActive = value === tips;

          return (
            <Button
              px="13px"
              variant="outline"
              key={index}
              bg={isActive ? colors.lightGray : ''}
              onClick={() => handleChange(value)}
            >
              {value} Lei
            </Button>
          );
        })}
      </HStack>
    </IconBlock>
  );
};
